import markOnDark from '@/assets/Xtremand-light.png';
import markOnLight from '@/assets/Xtremand-dark.png';

/**
 * The address of the marketing site, which is not this application.
 *
 * <p>An absolute URL on purpose: it is a different site on a different origin, and
 * the router has no route for it. `/` here redirects into the application.
 */
export const MARKETING_SITE_URL = 'https://xtremand.com';

/**
 * The wordmark for a given theme, named for the ground it sits ON.
 *
 * <h2>Why this exists rather than two imports at each call site</h2>
 *
 * The filenames are actively misleading. `Xtremand-dark.png` is the DARK-coloured
 * mark, which is the one for a LIGHT background — so `actualTheme === 'dark' ?
 * dark : light` reads correctly and is exactly backwards. Six components carry
 * this pair; getting it wrong in one of them produces a logo that is invisible
 * rather than obviously broken, which is the kind of fault nobody reports.
 *
 * <p>So the mapping is made once, here, and the parameter is the theme rather than
 * the colour.
 */
export function brandMarkFor(theme: string): string {
  /*
   * There are six themes, not two -- light, dark, neomorphism, neomorphism-dark,
   * light-glass, dark-glass -- and the question here is only whether the ground is
   * dark. Matching on the suffix answers it for every one of them, and for the next
   * one, without this needing to know they exist.
   *
   * `string` rather than the union: ThemeProvider does not export the type, and
   * importing a component module for a type would drag the whole provider into any
   * consumer of this file.
   */
  return theme === 'dark' || theme.endsWith('-dark') ? markOnDark : markOnLight;
}
